// removed by extract-text-webpack-plugin
module.exports = {"CustomAllocations":"CustomAllocations__CustomAllocations__3eCnN","custom-allocation-slidedown":"CustomAllocations__custom-allocation-slidedown__2MOgj","validationMessage":"CustomAllocations__validationMessage__21RTW","totalDiv":"CustomAllocations__totalDiv__1OYof","invalidTotal":"CustomAllocations__invalidTotal___UV61"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CustomAllocations/CustomAllocations.css
// module id = 498
// module chunks = 0